/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductNumberThumbnail
 */
export interface ProductNumberThumbnail {
    /**
     * 
     * @type {string}
     * @memberof ProductNumberThumbnail
     */
    productNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductNumberThumbnail
     */
    thumbnailUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductNumberThumbnail
     */
    price?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductNumberThumbnail
     */
    productName?: string;
}

/**
 * Check if a given object implements the ProductNumberThumbnail interface.
 */
export function instanceOfProductNumberThumbnail(value: object): value is ProductNumberThumbnail {
    return true;
}

export function ProductNumberThumbnailFromJSON(json: any): ProductNumberThumbnail {
    return ProductNumberThumbnailFromJSONTyped(json, false);
}

export function ProductNumberThumbnailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductNumberThumbnail {
    if (json == null) {
        return json;
    }
    return {
        
        'productNumber': json['productNumber'] == null ? undefined : json['productNumber'],
        'thumbnailUrl': json['thumbnailUrl'] == null ? undefined : json['thumbnailUrl'],
        'price': json['price'] == null ? undefined : json['price'],
        'productName': json['productName'] == null ? undefined : json['productName'],
    };
}

export function ProductNumberThumbnailToJSON(json: any): ProductNumberThumbnail {
    return ProductNumberThumbnailToJSONTyped(json, false);
}

export function ProductNumberThumbnailToJSONTyped(value?: ProductNumberThumbnail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'productNumber': value['productNumber'],
        'thumbnailUrl': value['thumbnailUrl'],
        'price': value['price'],
        'productName': value['productName'],
    };
}

